import type { PlaycastMessage } from '../types';
import type { PlaycastMessageProcessMacroSequence, PlaycastMessageProcessMacroSequenceReply, PlaycastMessageProcessMacroSequenceEvent } from '../types/messages/process';
import { nativeSequenceCommandSchema, nativeSequenceReplySchema, nativeSequenceEventSchema,
  type NativeSequenceCommand, type NativeSequenceReply, type NativeSequenceEvent } from '../types/api/macroGraph';
import { formatMessage } from './_util/formatMessage';

export function macroSequence(command: NativeSequenceCommand): PlaycastMessage<PlaycastMessageProcessMacroSequence> {
  return formatMessage('host', 'host', { target: 'process', action: 'macroSequence', isReply: false,
    message: nativeSequenceCommandSchema.parse(command) }) as PlaycastMessage<PlaycastMessageProcessMacroSequence>;
}
export function macroSequenceReply(reply: NativeSequenceReply): PlaycastMessage<PlaycastMessageProcessMacroSequenceReply> {
  return formatMessage('host', 'playjector', { target: 'process', action: 'macroSequence', isReply: true,
    message: nativeSequenceReplySchema.parse(reply) }) as PlaycastMessage<PlaycastMessageProcessMacroSequenceReply>;
}
export function macroSequenceEvent(event: NativeSequenceEvent): PlaycastMessage<PlaycastMessageProcessMacroSequenceEvent> {
  return formatMessage('host', 'playjector', { target: 'process', action: 'macroSequenceEvent', isReply: true,
    message: nativeSequenceEventSchema.parse(event) }) as PlaycastMessage<PlaycastMessageProcessMacroSequenceEvent>;
}
